import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    margin: "0 5px",
    padding: "5px 12px 12px 12px",
    scrollSnapAlign: "start",
    border: (props) => (props.mobileListView ? "unset" : theme.shape.border),
    borderRadius: (props) => (props.mobileListView ? 0 : 10),
    marginBottom: (props) => (props.mobileListView ? 10 : 0),
    boxSizing: "border-box",
    // This applies borderRadius on safari
    "-webkit-mask-image": "-webkit-radial-gradient(white, black)",
    "&:hover": {
      "@media (hover: hover) and (pointer: fine)": {
        '& [id^="next-photo-button-"], & [id^="previous-photo-button-"]': {
          opacity: 0.75,
          transition: "opacity 0.4s ease 0s",
        },
      },
    },
  },
  title: {
    ...theme.mixins.noOverflowText,
    width: "100%",
  },
  details: {
    flex: "1 0 auto",
    padding: 12,
    display: "flex",
    flexDirection: "column",
  },
  mainContent: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
  },
  bottomContent: {
    display: "flex",
  },
  imageContainer: {
    position: "relative",
    maxWidth: 450,
    marginLeft: "auto",
    marginRight: "auto",
    "& img": {
      borderRadius: (props) => (props.mobileListView ? "8px" : "8px 8px 0 0"),
    },
  },
  imageChip: {
    position: "absolute",
    top: 6,
    left: 7,
    zIndex: theme.zIndex.vehicleCardChip,
  },
  cardImg: {
    width: "100%",
    maxHeight: 300,
    minHeight: 150,
    height: "50vw",
    objectFit: "cover",
    objectPosition: "center",
  },
  lightText: {
    fontSize: 12,
    fontWeight: 300,
    lineHeight: "21px",
    display: "inline-flex",
  },
  cardIcon: {
    marginRight: 3,
  },
}));
